import {jobsSubmittedAction, downloadedProductsAction} from "./actions";
import {
  downloadAllProducts, submitAllJobs
} from "../../helpers/cartHelper";
import {DownloadType, InvalidationJobType, JobType, ReprocessingJobType} from "../../types/cart";
import {clearProductSelectionsDispatchAction} from "../product/dispatchActions";
import {
  errorToastNotification,
  successToastNotification,
  warningToastNotification
} from "../../helpers/toastNotificationHelper";
import {
  getDownloadErrorMessageBy,
  getSubmitErrorMessageBy
} from "../../helpers/errorsHelper";
import {AppParametersType} from "../../types/app";
import translations from "../../translations";

export const downloadProductsAction = (
  win,
  appParameters: AppParametersType,
  downloads: DownloadType[]
) => (dispatch) => {
  // la count è stata già effettuata
  // preparo gli item da inviare alla coda di download
  const downloadsToSend = downloads.filter((downloadItem) => downloadItem)
    .map((downloadItem) => {
      return {
        url: `${process.env.REACT_APP_MAPIT}${process.env.REACT_APP_MAPIT_DOWNLOAD}${downloadItem.id}`,
        name: `STAC Item ${downloadItem.id}`,
        filename: downloadItem.filename
      }
    });
  console.log("Sending downloads to queue...");
  win.parent.postMessage({queueItems: downloadsToSend}, "*");
  return new Promise((resolve) => resolve(true));
  // versione con link -------------------------------------------------------------------------------------------------
  // return downloadAllProducts(appParameters, downloads)
  //   .then((results) => {
  //     const {
  //       valid,
  //       errors
  //     } = results;
  //     if (valid.length > 0) {
  //       if (errors.length > 0) {
  //         warningToastNotification(translations("unableDownloadAllProducts", appParameters.language), {hideAfter: 7})
  //       } else {
  //         successToastNotification(translations("productsDownloaded", appParameters.language), {hideAfter: 7})
  //       }
  //       dispatch(downloadedProductsAction(valid));
  //       dispatch(clearProductSelectionsDispatchAction());
  //       // actually tries downloading
  //       // TODO: verificare validità del token
  //       const accessToken = sessionStorage.getItem("jwtAuth");
  //       const tempLink = document.createElement("a");
  //       // tempLink.target = "_blank"; // scaricamento come popup
  //       tempLink.style.display = "none";
  //       document.body.appendChild(tempLink);
  //       valid.forEach((downloadable, index) => {
  //         setTimeout(() => {
  //           console.log(`Triggering download of ${downloadable.id}`);
  //           tempLink.href = `${process.env.REACT_APP_MAPIT}${process.env.REACT_APP_MAPIT_DOWNLOAD}${downloadable.id}?auth=${accessToken}`;
  //           tempLink.click();
  //         }, 1000 * index);
  //       });
  //       document.body.removeChild(tempLink);
  //     }
  //     errors.forEach((error) => {
  //       errorToastNotification(getDownloadErrorMessageBy(error, appParameters.language), {hideAfter: 7})
  //     });
  //     return results;
  //   });
};

export const submitJobAction = (
  win,
  appParameters: AppParametersType,
  job: JobType | InvalidationJobType | ReprocessingJobType
) => (dispatch) => {
  return submitAllJobs(appParameters, [job])
    .then((results) => {
      const {
        valid,
        errors
      } = results;
      if (valid.length > 0) {
        if (errors.length > 0) {
          warningToastNotification(translations("unableSubmitAllJobs", appParameters.language), {hideAfter: 7})
        } else {
          successToastNotification(translations("jobsSubmitted", appParameters.language), {hideAfter: 7})
        }
        dispatch(jobsSubmittedAction(valid));
        dispatch(clearProductSelectionsDispatchAction());
      }
      errors.forEach((error) => {
        errorToastNotification(getSubmitErrorMessageBy(error, appParameters.language), {hideAfter: 7})
      });
      return results;
    });
};
